import template from './acris-faq-detail.html.twig';

const { Component, Context, Utils, Mixin } = Shopware;
const { isEmpty } = Utils.types;
const { Criteria } = Shopware.Data;

Component.register('acris-faq-detail', {
    template,

    inject: ['repositoryFactory', 'context', 'acl', 'cmsService'],

    emits: ['modal-close', 'modal-save'],

    mixins: [
        Mixin.getByName('notification'),
        Mixin.getByName('placeholder')
    ],

    watch: {
        'item.media'() {
            if (this.item && this.item.media && this.item.media.id) {
                this.setMediaItem({ targetId: this.item.media.id });
            }
        }
    },

    data() {
        return {
            item: null,
            isLoading: false,
            processSuccess: false,
            repository: null,
            showDocumentModal: false,
            documentDefaultFolderId: null,
            mediaItem: null,
            uploadTag: 'acris-faq-upload-tag',
            isSaveSuccessful: false,
            categoriesCollection: [],
            currentKeyword: null,
            showAddKeywordModal: false,
            showEditKeywordModal: false,
            showDeleteKeywordModal: false,
            keywordSortDirection: '',
            keywordSortProperty: null,
            domainPlaceholder: '124c71d524604ccbad6042edce3ac799',
        };
    },

    computed: {
        isDisabled() {
            return this.isLoading
                || !this.item.name
                || !this.item.description
                || (this.item.layout === 'cms' && (!this.item.cmsPageId))
                || (this.item.layout === 'default' && (!this.item.imagePosition || !this.item.imageSize || !this.item.videoPosition || !this.item.videoType || !this.item.groups || this.item.groups.length < 1))
        },

        faqCriteria() {
            const criteria = new Criteria(this.page, this.limit);
            criteria.addAssociation('media');
            criteria.addAssociation('groups');
            criteria.addAssociation('acrisFaqDocuments');
            criteria.addAssociation('salesChannels');
            criteria.addAssociation('rules');
            criteria.addAssociation('products');
            criteria.addAssociation('products.options');
            criteria.addAssociation('products.options.group');
            criteria.addAssociation('keywords');
            criteria.addAssociation('seoUrls');

            criteria.getAssociation('seoUrls')
                .addFilter(Criteria.equals('isCanonical', true));

            return criteria
        },

        keywordColumns() {
            return this.getKeywordColumns();
        },
        faqKeywordRepository() {
            return this.repositoryFactory.create('acris_faq_keyword');
        },

        mediaRepository() {
            return this.repositoryFactory.create('media');
        },

        faqDocumentsRepository() {
            return this.repositoryFactory.create(this.item.acrisFaqDocuments.entity);
        },

        faqRepository() {
            return this.repositoryFactory.create('acris_faq');
        },

        imagePositionOptions() {
            return [
                { label: this.$tc('acris-faq.detail.fieldSelectOptionRight'), value: 'right' },
                { label: this.$tc('acris-faq.detail.fieldSelectOptionLeft'), value: 'left' },
                { label: this.$tc('acris-faq.detail.fieldSelectOptionTop'), value: 'top' },
                { label: this.$tc('acris-faq.detail.fieldSelectOptionBottom'), value: 'bottom' }
            ]
        },

        imageSizeOptions() {
            return [
                { label: this.$tc('acris-faq.detail.fieldSelectOptionSizeSmall'), value: 'small' },
                { label: this.$tc('acris-faq.detail.fieldSelectOptionSizeMedium'), value: 'medium' },
                { label: this.$tc('acris-faq.detail.fieldSelectOptionSizeLarge'), value: 'large' }
            ]
        },

        imageUrlTargetOptions() {
            return [
                { label: this.$tc('acris-faq.detail.fieldSelectOptionNewWindow'), value: '_blank' },
                { label: this.$tc('acris-faq.detail.fieldSelectOptionThisWindow'), value: '_self' }
            ]
        },

        videoPositionOptions() {
            return [
                { label: this.$tc('acris-faq.detail.fieldSelectOptionRight'), value: 'right' },
                { label: this.$tc('acris-faq.detail.fieldSelectOptionLeft'), value: 'left' },
                { label: this.$tc('acris-faq.detail.fieldSelectOptionTop'), value: 'top' },
                { label: this.$tc('acris-faq.detail.fieldSelectOptionBottom'), value: 'bottom' }
            ]
        },

        videoTypeOptions() {
            return [
                { label: this.$tc('acris-faq.detail.fieldSelectOptionYoutube'), value: 'youtube' },
                { label: this.$tc('acris-faq.detail.fieldSelectOptionCustom'), value: 'custom' },
            ]
        },

        collapseOptions() {
            return [
                { label: this.$tc('acris-faq.detail.fieldSelectOptionsCollapsed'), value: 'isCollapsed' },
                { label: this.$tc('acris-faq.detail.fieldSelectOptionsNotCollapsed'), value: 'notCollapsed' },
            ]
        },

        urlTypeOptions() {
            return [
                { label: this.$tc('sw-category.base.link.type.external'), value: 'external' },
                { label: this.$tc('sw-category.base.link.type.internal'), value: 'internal' },
            ]
        },

        urlEntityOptions() {
            return [
                { label: this.$tc('global.entities.product'), value: 'product' },
                { label: this.$tc('global.entities.category'), value: 'category' },
                { label: this.$tc('global.entities.landing_page'), value: 'landing_page' }
            ]
        },

        layoutOptions() {
            return [
                { label: this.$tc('acris-faq.detail.fieldSelectOptionLayoutDefault'), value: 'default' },
                { label: this.$tc('acris-faq.detail.fieldSelectOptionLayoutCms'), value: 'cms' }
            ]
        },

        metaDataOptions() {
            return [
                {label: this.$tc('acris-faq.detail.fieldSelectOptionMetaDataShow'), value: 'show'},
                {label: this.$tc('acris-faq.detail.fieldSelectOptionMetaDataHide'), value: 'hide'}
            ]
        },

        mediaDefaultFolderRepository() {
            return this.repositoryFactory.create('media_default_folder');
        },

        documentRepository() {
            return this.repositoryFactory.create('acris_faq_document');
        },

        documentDefaultFolderCriteria() {
            const criteria = new Criteria(1, 1);

            criteria.addAssociation('folder');
            criteria.addFilter(Criteria.equals('entity', 'acris_faq_document'));

            return criteria;
        },

        productContext() {
            return { ...Shopware.Context.api, inheritance: true }
        },

        productCriteria() {
            const criteria = new Criteria(1, 25);
            criteria.addAssociation('options.group');

            return criteria;
        },

        categoryCriteria() {
            const criteria = new Criteria(1, 25);
            criteria.addFilter(Criteria.equals('type', 'page'));

            return criteria;
        },

        categoryRepository() {
            return this.repositoryFactory.create('category');
        },

        isNewItem() {
            return this.item._isNew;
        },

        technicalUrl() {
            return `${this.domainPlaceholder}/faq/detail/${this.item.id}#`;
        }
    },

    metaInfo() {
        return {
            title: this.$createTitle()
        };
    },

    created() {
        this.createdComponent();
    },

    methods: {
        createdComponent() {
            this.getEntity();
            this.getDocumentDefaultFolderId().then((documentDefaultFolderId) => {
                this.documentDefaultFolderId = documentDefaultFolderId;
            });
        },

        onCancel() {
            this.$emit('modal-close');
        },

        onApply() {
            this.$emit('modal-save', this.documentItem);
        },

        updateCmsPage(cmsPage) {
            if (!this.item) {
                return;
            }

            this.item.cmsPageId = cmsPage?.id;
            this.item.cmsPageVersionId = cmsPage?.versionId;
        },

        getKeywordColumns() {
            return [{
                property: 'name',
                label: this.$tc('acris-faq.detail.fieldTitleLabelKeywordName')
            }, {
                property: 'matchingType',
                label: this.$tc('acris-faq.detail.fieldTitleLabelMatchingType')
            }];
        },

        setKeywordSorting(column) {
            this.fieldSortProperty = column.property;

            let direction = 'ASC';
            if (this.fieldSortProperty === column.dataIndex) {
                if (this.fieldSortDirection === direction) {
                    direction = 'DESC';
                }
            }
            this.fieldSortProperty = column.dataIndex;
            this.fieldSortDirection = direction;
        },

        onCreateNewKeyword() {
            this.showAddKeywordModal = true;
            this.createNewKeyword();
        },

        createNewKeyword() {
            const newKeyword = this.faqKeywordRepository.create(Shopware.Context.api);
            newKeyword.matchingType = 'strict';

            this.currentKeyword = newKeyword;
        },

        onSaveKeyword() {
            if (this.currentKeyword === null) {
                return;
            }
            let keyword = this.item.keywords.get(this.currentKeyword.id);

            if (typeof keyword === 'undefined' || keyword === null) {
                keyword = this.faqKeywordRepository.create(Shopware.Context.api, this.currentKeyword.id);
            }

            Object.assign(keyword, this.currentKeyword);

            if (!this.item.keywords.has(keyword.id)) {
                this.item.keywords.push(keyword);
            }

            this.currentKeyword = null;
            this.$refs.keywordGrid.createdComponent();
        },

        onCloseKeywordModal() {
            if (this.$route.query.hasOwnProperty('detailId')) {
                this.$route.query.detailId = null;
            }

            this.currentKeyword = null;
        },

        onEditKeyword(id) {
            const currentKeyword = this.faqKeywordRepository.create(Shopware.Context.api, id);

            Object.assign(currentKeyword, this.item.keywords.get(id));

            this.currentKeyword = currentKeyword;

            this.showEditKeywordModal = id;
        },

        onDeleteKeyword(id) {
            this.showDeleteKeywordModal = id;
        },

        onConfirmDeleteKeyword(id) {
            this.onCloseDeleteKeywordModal();

            this.$nextTick(() => {
                this.item.keywords.remove(id);
            });
            this.$refs.keywordGrid.createdComponent();
        },

        onCloseDeleteKeywordModal() {
            this.showDeleteFieldModal = false;
        },

        onCreateLayout() {
            if (!this.item) {
                return;
            }

            this.$router.push({
                name: 'sw.cms.create'
            });
        },

        getDocumentDefaultFolderId() {
            return this.mediaDefaultFolderRepository.search(this.documentDefaultFolderCriteria, Context.api)
                .then((documentDefaultFolder) => {
                    const defaultFolder = documentDefaultFolder.first();

                    if (defaultFolder.folder && defaultFolder.folder.id) {
                        return defaultFolder.folder.id;
                    }

                    return null;
                });
        },

        onOpenDocumentModal() {
            this.showDocumentModal = true;
        },

        onCloseDocumentModal() {
            this.showDocumentModal = false;
        },

        onAddDocument(document) {
            if (isEmpty(document)) {
                return;
            }

            document.forEach((item) => {
                this.addDocument(item).catch(({ fileName }) => {
                    this.createNotificationError({
                        message: this.$tc('sw-product.mediaForm.errorMediaItemDuplicated', { fileName }, 0)
                    });
                });
            });
        },

        addDocument(document) {
            if (this.isExistingDocument(document)) {
                return Promise.reject(document);
            }

            const newDocument = this.documentRepository.create(Context.api);
            newDocument.mediaId = document.id;
            newDocument.document = {
                url: document.url,
                id: document.id
            };

            this.item.acrisFaqDocuments.add(newDocument);

            return Promise.resolve();
        },

        isExistingDocument(document) {
            return this.item.acrisFaqDocuments.some(({ id, mediaId }) => {
                return id === document.id || mediaId === document.id;
            });
        },

        getEntity() {
            // Shopware.State.dispatch('cmsPageState/resetCmsPageState');

            this.faqRepository
                .get(this.$route.params.id, Shopware.Context.api, this.faqCriteria)
                .then((entity) => {
                    this.item = entity;
                    this.getCategoriesCollection();
                });
        },

        onClickSave() {
            this.isLoading = true;
            const titleSaveError = this.$tc('acris-faq.detail.titleSaveError');
            const messageSaveError = this.$tc('acris-faq.detail.messageSaveError');
            const titleSaveSuccess = this.$tc('acris-faq.detail.titleSaveSuccess');
            const messageSaveSuccess = this.$tc('acris-faq.detail.messageSaveSuccess');

            this.isSaveSuccessful = false;
            this.isLoading = true;

            this.faqRepository
                .save(this.item, Shopware.Context.api)
                .then(() => {
                    this.getEntity();
                    this.isLoading = false;
                    this.processSuccess = true;
                    this.createNotificationSuccess({
                        title: titleSaveSuccess,
                        message: messageSaveSuccess
                    });
                }).catch(() => {
                    this.isLoading = false;
                    this.createNotificationError({
                        title: titleSaveError,
                        message: messageSaveError
                    });
                });
        },

        onSelectionAdd(item) {
            if (item) {
                this.emptyCategoriesCollection();
                this.setCategoriesCollection(item);
                this.categoriesCollection.add(item);
            }
        },

        emptyCategoriesCollection() {
            const ids = [];

            for (let i = 0; i < this.categoriesCollection.length; i++) {
                if (this.categoriesCollection.has(this.categoriesCollection[i].id)) {
                    ids.push(this.categoriesCollection[i].id);
                }
            }

            for (let j = 0; j < ids.length; j++) {
                this.categoriesCollection.remove(ids[j]);
            }
        },

        setCategoriesCollection(item) {
            if (!item.id) {
                this.item.imageInternalLink = null;
            } else {
                const criteria = new Criteria();
                criteria.addAssociation('children');
                criteria.getAssociation('children')
                    .addSorting(Criteria.sort('autoIncrement', 'ASC'));
                this.categoryRepository.get(item.id, this.categorySelectContext, criteria).then((category) => {
                    this.item.imageInternalLink = category.id;
                });
            }
        },

        getCategoriesCollection() {
            if (!this.item.imageInternalLink) {
                const criteria = new Criteria();
                criteria.addFilter(Criteria.equals('level', '9999'));
                criteria.setLimit(1);
                criteria.addAssociation('children');

                return this.categoryRepository.search(criteria, this.categorySelectContext).then((categoriesCollection) => {
                    this.categoriesCollection = categoriesCollection;
                });
            }
            const criteria = new Criteria();
            criteria.addFilter(Criteria.equals('id', this.item.imageInternalLink));
            criteria.setLimit(1);
            criteria.addAssociation('children');

            return this.categoryRepository.search(criteria, this.categorySelectContext).then((categoriesCollection) => {
                this.categoriesCollection = categoriesCollection;
            });
        },

        changeEntity() {
            this.item.imageInternalLink = null;
        },


        // onSelectionAdd(selection) {
        //     this.item.imageInternalLink = selection.id;
        // },

        onSelectionRemove() {
            this.item.imageInternalLink = null;
        },

        saveFinish() {
            this.processSuccess = false;
        },

        onChangeLanguage() {
            this.getEntity();
        },

        setMediaItem({ targetId }) {
            this.item.mediaId = targetId;
        },

        onDropMedia(mediaItem) {
            this.setMediaItem({ targetId: mediaItem.id });
        },

        setMediaFromSidebar(mediaEntity) {
            this.item.mediaId = mediaEntity.id;
        },

        onUnlinkAvatar() {
            this.item.mediaId = null;
        },

        openMediaSidebar() {
            this.$refs.mediaSidebarItem.openContent();
        },

        onAddDocumentItemToFaq(mediaItem) {
            if (this._checkIfDocumentMediaIsAlreadyUsed(mediaItem.id)) {
                this.createNotificationInfo({
                    message: this.$tc('sw-product.mediaForm.errorMediaItemDuplicated')
                });
                return false;
            }

            this.addDocumentMedia(mediaItem).then((mediaId) => {
                // TODO: check if $root needed
                // this.$root.$emit('document-media-added', mediaId);
                return true;
            }).catch(() => {
                this.createNotificationError({
                    title: this.$tc('sw-product.mediaForm.errorHeadline'),
                    message: this.$tc('sw-product.mediaForm.errorMediaItemDuplicated')
                });

                return false;
            });
            return true;
        },

        addDocumentMedia(mediaItem) {
            this.isLoading = true;
            // return error if media exists
            if (this.item.acrisFaqDocuments.has(mediaItem.id)) {
                this.isLoading = false;
                // eslint-disable-next-line prefer-promise-reject-errors
                return Promise.reject('A media item with this id exists');
            }

            const newMedia = this.createDocumentAssociation(mediaItem.id);

            return new Promise((resolve) => {
                this.item.acrisFaqDocuments.add(newMedia);

                this.isLoading = false;

                resolve(newMedia.mediaId);
                return true;
            });
        },

        createDocumentAssociation(targetId) {
            const faqDocuments = this.faqDocumentsRepository.create(Shopware.Context.api);

            faqDocuments.faqId = this.item.id;
            faqDocuments.mediaId = targetId;

            if (this.item.acrisFaqDocuments.length <= 0) {
                faqDocuments.position = 0;
            } else {
                faqDocuments.position = this.item.acrisFaqDocuments.length;
            }
            return faqDocuments;
        },

        _checkIfDocumentMediaIsAlreadyUsed(mediaId) {
            return this.item.acrisFaqDocuments.some((productMedia) => {
                return productMedia.mediaId === mediaId;
            });
        },
        onSalesChannelChange(newSalesChannels) {
            this.item.salesChannels = newSalesChannels;
        },
        onRulesChange(newRules) {
            this.item.rules = newRules;
        },

        onItemProductChange(collection) {
            this.item.products = collection;
        },
        onDuplicate(item) {
            this.faqKeywordRepository.clone(item.id, Shopware.Context.api).then((newKeyword) => {
                this.faqKeywordRepository.get(newKeyword.id, Shopware.Context.api).then((newKeyword) => {
                    this.item.keywords.add(newKeyword);

                    this.onEditKeyword(newKeyword.id);
                });
            });
        },
        onProductStreamChange(newProductStreams) {
            this.item.productStreams = newProductStreams;
        },
        onGroupsChange(newFaqGroups) {
            this.item.groups = newFaqGroups;
        }
    }
});
